





import { Component, Vue } from 'vue-property-decorator'

@Component({
     props: ["title"]
 })
export default class CurrentStepTitle extends Vue {}

